import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { productPeripheralStates, titleForProductPeripheralState } from 'zens-store'

interface Props extends Omit<SelectProps<number | number[]>, 'items' | 'onSelect'> {
  onChange?: (value: number | number[]) => void
}
const PeripheralsSelect = (props: Props) => {
  const { onChange, value, ...otherProps } = props
  const { t } = useTranslation()

  const items = productPeripheralStates.map((status) => ({
    value: status,
    title: titleForProductPeripheralState(status, t),
  }))
  return (
    <Select
      value={value || 'all'}
      onSelect={onChange}
      items={items}
      testID="PeripheralsSelect.Container"
      {...otherProps}
    />
  )
}

export default PeripheralsSelect
